<div class="mx-2 ta-c">
    <div class="mat-display-3 mt-4 mb-2">Merch</div>

    <div class="mat-title">I got merch and I aint afraid to sell it</div>
    <div class="mat-subheading-2">Get these designs on a hat or t-shirt or sticker or throw cushion, whatever takes your fancy</div>

    <div class="ta-c">
        <iframe
            [src]="safeRbUrl"
            frameborder="0"
            [width]="240 * columns + 26"
            [height]="222 * rows + 85"
            scrolling="no"
            allowTransparency="true"
        ></iframe>
    </div>
</div>